import { useErrorText } from '../../api/hooks.ts';
import styles from './Games.module.css';

/** A translated error message as an alert; renders nothing when there is no error. */
export function ErrorText({ error }: { error: unknown }) {
  const errorText = useErrorText();
  if (error === null || error === undefined) return null;
  return (
    <p role="alert" className={styles['error']}>
      {errorText(error)}
    </p>
  );
}
